import { apiClient } from './axios';

export interface ProfessionalBusiness {
  id: string;
  name: string;
  businessTypes: string[] | null;
  email: string | null;
  phone: string | null;
  logoUrl: string | null;
}

export interface SearchProfessionalsResponse {
  businesses: ProfessionalBusiness[];
}

export interface InviteProfessionalRequest {
  name: string;
  email?: string;
  phone?: string;
  type: 'veterinary' | 'grooming' | 'training' | 'other';
  petId: string;
  businessId?: string;
}

export interface InviteProfessionalResponse {
  success: boolean;
  emailSent: boolean;
  invitationId: string;
}

export async function searchProfessionals(
  query: string,
  type?: string,
): Promise<SearchProfessionalsResponse> {
  const params = new URLSearchParams({ q: query });
  if (type) params.set('type', type);
  const response = await apiClient.get<SearchProfessionalsResponse>(
    `/professionals/search?${params.toString()}`,
  );
  return response.data;
}

export interface BusinessService {
  id: string;
  name: string;
  category: string;
  businessType: string;
  serviceDetail: string | null;
  description: string;
  duration: number;
  price: number;
  currency: string;
  location: 'on-site' | 'home' | 'remote' | 'any';
  isActive: boolean;
}

export async function listBusinessServices(
  businessId: string,
): Promise<BusinessService[]> {
  const response = await apiClient.get<{ services: BusinessService[] }>(
    `/professionals/${businessId}/services`,
  );
  return response.data.services ?? [];
}

export async function inviteProfessional(
  data: InviteProfessionalRequest,
): Promise<InviteProfessionalResponse> {
  const response = await apiClient.post<InviteProfessionalResponse>(
    '/professionals/invite',
    data,
  );
  return response.data;
}
